import React, { useEffect, useState } from 'react';

// icons
import { RxMinus } from "react-icons/rx";
import { GoPlus } from "react-icons/go";
import { FaTrash } from 'react-icons/fa';

// styling
import { Spacing } from '_styles';

const CustomQuantityClicker = (props) => {

    return (
        <div style={styles.container}>

            {/* minus */}
            <button
                onClick={() => props.subtract()}
                disabled={props.minusDisabled}
                style={styles.button}>
                {props.quantity === 1
                    ? <FaTrash size={18} style={{ marginRight: Spacing.SCALE_8 }} color={'black'}/>
                    : <RxMinus size={28} color={'black'} />
                }
            </button>

            {/* quantity */}
            <div style={styles.quantityContainer}>
                <span style={styles.quantity}>{props.quantity}</span>
            </div>

            {/* add */}
            <button
                onClick={() => props.add()}
                disabled={props.plusDisabled}
                style={styles.button}>
                <GoPlus size={28} color={'black'} style={{ opacity: props.plusDisabled ? 0.2 : 1.0 }} />

            </button>

        </div>
    );
};

const styles = {
    container: {
        backgroundColor: 'lightgrey',
        borderRadius: 50,
        display: 'flex', justifyContent: 'space-between',
        padding: Spacing.SCALE_8
    },
    quantityContainer: {
        marginLeft: Spacing.SCALE_8, marginRight: Spacing.SCALE_8,
        display: 'flex', flex: 1, justifyContent: 'center',
        alignItems: 'center', alignItems: 'center', textAlign: 'center',
    },
    quantity: {
        alignItems: 'center', alignSelf: 'center',
        fontSize: 18
    },
    button: {
        borderWidth: 0
    },
}

export default CustomQuantityClicker;
